import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

export const BrandMark = () => (
  <section className="relative py-16 md:py-20 overflow-hidden" data-testid="brand-mark">
    <div className="max-w-5xl mx-auto px-6 flex items-center gap-6 md:gap-10">
      <div className="hidden sm:block flex-1 h-px bg-gradient-to-r from-transparent via-[#E84C4C]/30 to-[#E84C4C]/50" />
      <Reveal className="flex flex-col items-center text-center">
        <motion.div
          initial={{ scale: 0.85, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="arch-shape relative overflow-hidden w-[104px] h-[156px] md:w-[124px] md:h-[186px]" style={{ background: "linear-gradient(160deg, #E84C4C 0%, #d13d55 35%, #F3A0A0 70%, #FAD0C4 100%)", boxShadow: "0 0 70px rgba(232,76,76,0.35), inset 0 0 40px rgba(255,255,255,0.15)" }}>
            <div className="absolute top-0 bottom-0 left-1/2 -translate-x-1/2 w-[7%] bg-white" />
            <div className="absolute left-0 right-0 h-[5%] bg-white" style={{ top: "36%" }} />
            <div className="absolute inset-0 glow-pulse" style={{ background: "radial-gradient(circle at 50% 28%, rgba(255,255,255,0.5) 0%, transparent 55%)" }} />
            <motion.div
              initial={{ x: "-140%" }}
              whileInView={{ x: "160%" }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: 0.5, duration: 1.4, ease: "easeInOut" }}
              className="absolute inset-y-0 w-1/2 -skew-x-12"
              style={{ background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.65), transparent)" }}
            />
          </div>
          <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-[150px] h-8 rounded-full blur-2xl" style={{ background: "rgba(232,76,76,0.3)" }} />
        </motion.div>
        <div className="mt-8 leading-none">
          <span className="font-orbitron font-black text-3xl md:text-4xl tracking-[0.18em] text-[#120716]">DIGITAL</span>
          <span className="block mt-2 font-orbitron text-xs md:text-sm tracking-[0.7em] text-[#E84C4C] pl-[0.7em]">MISSIONS</span>
        </div>
        <p className="mt-6 text-[10px] md:text-xs font-orbitron tracking-[0.35em] text-[#120716]/50" data-testid="brand-tagline">
          CHURCHES. PEOPLE. A BRIGHTER TOMORROW.
        </p>
        <a href="https://digitalmissions.ai" data-testid="brand-domain" className="mt-5 inline-flex items-center gap-3 font-orbitron text-[11px] md:text-xs tracking-[0.3em] text-[#E84C4C] hover:text-[#c13b3b] transition-colors">
          <span className="w-6 h-px bg-[#E84C4C]/60" />DIGITALMISSIONS.AI<span className="w-6 h-px bg-[#E84C4C]/60" />
        </a>
      </Reveal>
      <div className="hidden sm:block flex-1 h-px bg-gradient-to-l from-transparent via-[#E84C4C]/30 to-[#E84C4C]/50" />
    </div>
  </section>
);
